import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    state() {
        return {
            token: "",
            deliveryAddress: {
                Street: "Jana brzechwy",
                StreetNo: "5",
                City: "Rumia",
                PostalCode: "84-23",
                Lat: "",
                Lng: "",
            },
            testMode: false,
            directionServiceResults: false,
            divisionName: "",
            divisionSymbolExternal: "",
            deliveryCost: {
                inZoneDelivery: 0,
                paidDistanceDelivery: 0,
            },
            deliveryDistances: {
                total: 0,
                paid: 0,
            },
            pokId: 0,
            orderType: "", // [orderToPay, doubleOrder]
            orderCreated: false,
            linkToPay: "",

            urls: {
                getOrderDataForPayu: "/order/getPaymentsDetails",
                startPayment: "/startPayment",
                warehousesList: "/vendor/warehousesList/",
                getWhLocation: "/vendor/warehouse/",
                getZones: "/warehouse/getZones/",
                getPaymentsMethods: "/getPaymentsMethods/",
                getDeliveryData: "/delivery/getDeliveryData",
                getDeliveryZone: "/delivery/getZone/",
                outOfZone: "/delivery/test/outOfZone/",
                getDeliveryPrice: "/delivery/test/getDelivPrice/",
                getDates: "/delivery/getDates/",
                createFullOrder: "/api/order/createFullOrder",
                createDoubleOrder: "/order/createDoubleOrder/",
                createOrderToPay: "/order/createOrderToPay/",
            },
            urlsAAA: {
                warehousesList: "/callcenterApi/vendor/warehousesList/",
                getWhLocation: "/callcenterApi/vendor/warehouse/",
                getZones: "/callcenterApi/warehouse/getZones/",
                getPaymentsMethods: "/callcenterApi/getPaymentsMethods/",
                getDeliveryData: "/callcenterApi/delivery/getDeliveryData",
                getDeliveryZone: "/callcenterApi/delivery/getZone/",
                outOfZone: "/callcenterApi/delivery/test/outOfZone/",
                getDeliveryPrice: "/callcenterApi/delivery/test/getDelivPrice/",
                getDates: "/callcenterApi/delivery/getDates/",
                createFullOrder: "/callcenterApi/api/order/createFullOrder",
                createDoubleOrder: "/callcenterApi/order/createDoubleOrder/",
                createOrderToPay: "/callcenterApi/order/createOrderToPay/",
            },
        };
    },
    mutations: {
        setPokId: function (state, value) {
            state.pokId = value;
        },
        setDivisionName: function (state, value) {
            state.divisionName = value;
        },
        setDivisionExternalSymbol: function (state, value) {
            state.divisionSymbolExternal = value;
        },
        setDeliveryCostInZone: function (state, value) {
            state.deliveryCost.inZoneDelivery = value;
        },
        setDeliveryCostPaidDistance: function (state, value) {
            state.deliveryCost.paidDistanceDelivery = value;
        },
        setDeliveryLocation: function (state, value) {
            state.deliveryAddress.Lat = value.Lat;
            state.deliveryAddress.Lng = value.Lng;
        },
        setDeliveryDistTotal: function (state, value) {
            state.deliveryDistances.total = value;
        },
        setDeliveryDistPaid: function (state, value) {
            state.deliveryDistances.paid = value;
        },
        setOrderType: function (state, value) {
            state.orderType = value;
        },
        setLinkToPay: function (state, value) {
            state.linkToPay = value;
        },
        setOrderCreated: function (state, value) {
            state.orderCreated = value;
        },
        setDirectionServiceResults: function (state, value) {
            state.directionServiceResults = value;
        },
    },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js